import { signOut } from 'firebase/auth'
import { equalTo, get, orderByChild, query, ref } from 'firebase/database'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { toast } from 'react-toastify'
import Feed from '../../Components/Feed'
import NoContent from '../../Components/NoContent'
import PageContainer from '../../Components/PageContainer'
import Spinner from '../../Components/Spinner'
import { auth } from '../../firebase'
import cloudFunctions from '../../Helpers/cloudFunctions'

export default function Account() {
    const navigate = useNavigate()
    const [loadReady, setLoadReady] = useState(false)
    const [pastPolls, setPastPolls] = useState(undefined)
    const [user, setUser] = useState(null)
    const [following, setFollowing] = useState(false)
    const { uid } = useParams()
    const getUser = () => {
        cloudFunctions.getUser({ uid: uid }).then((res) => {
            const response = res.data
            if (response.error) {
                toast.error("User not found")
            } else {
                if (response.followers.includes(auth.currentUser.uid)) {
                    setFollowing(true)
                }
                setUser(response)
            }
        })
    }
    useEffect(() => {
        if (!auth.currentUser) {
            navigate("/login")
        } else {
            getUser()
            cloudFunctions.getUserPolls({ usrID: uid }).then((res) => {
                const response = res.data
                if (response.error) {
                    toast.error(response.msg)
                } else {
                    const pollsArray = new Array()
                    Object.keys(response.data).map((poll, idx) => {
                        pollsArray.push({ ...response.data[poll] })
                    })
                    if (pollsArray.length) {
                        setPastPolls(pollsArray.reverse())
                    } else {
                        setPastPolls(null)
                    }
                }
            })
        }
    }, [])
    useEffect(() => {
        if (user && (pastPolls !== undefined)) {
            setLoadReady(true)
        }
    }, [user, pastPolls])
    if (loadReady) {
        return (
            <PageContainer>
                <div style={{ padding: "0 30px", marginTop: 50 }} className="pgePadd">
                    <div className='flex aic' style={{ gap: 20, paddingBottom: 50, flexWrap: "wrap" }}>
                        {user.photoURL
                            ? <img src={user.photoURL} referrerpolicy="no-referrer" className="largePfp" />
                            : <img src={`https://ui-avatars.com/api/?background=0074D9&color=fff&name=${user.displayName}`} referrerpolicy="no-referrer" className="largePfp noBorder" alt="Profile picture" />
                        }
                        <div>
                            <h2 style={{ marginBottom: 15 }}>{user.displayName}</h2>
                            <div className='flex aic' style={{ gap: 15, opacity: .6 }}>
                                <p style={{ fontWeight: "600", marginTop: 0 }}>{user.followers?.length || 0} Followers</p>
                                <p style={{ fontWeight: "600", marginTop: 0 }}>{user.following?.length || 0} Following</p>
                                <p style={{ fontWeight: "600", marginTop: 0 }}>{pastPolls?.length || 0} Polls</p>
                            </div>
                            {uid === auth.currentUser.uid
                                ? <button className='b3' onClick={() => { signOut(auth); navigate("/home") }}>Logout</button>
                                : <>
                                    {following
                                        ? <button className='b6' onClick={() => {
                                            const loader = toast.loading("Unfollowing...")
                                            cloudFunctions.unfollowUser({ followID: uid }).then((res) => {
                                                const response = res.data
                                                if (response.error) {
                                                    toast.update(loader,
                                                        {
                                                            render: "Something went wrong",
                                                            icon: "❌"
                                                        }
                                                    )
                                                } else {
                                                    toast.update(loader,
                                                        {
                                                            render: "Unfollowed user",
                                                            icon: "✔️"
                                                        }
                                                    )
                                                    setFollowing(false)
                                                    getUser()
                                                }
                                            }).catch((err) => {
                                                toast.update(loader,
                                                    {
                                                        render: "Something went wrong",
                                                        icon: "❌"
                                                    }
                                                )
                                                toast.error("Something went wrong")
                                            }).finally(() => {
                                                setTimeout(() => {
                                                    toast.dismiss(loader)
                                                }, 2000)
                                            })
                                        }}>Unfollow</button>
                                        : <button className='b3' onClick={() => {
                                            const loader = toast.loading("Following...")
                                            cloudFunctions.followUser({ followID: uid }).then((res) => {
                                                const response = res.data
                                                if (response.error) {
                                                    toast.update(loader,
                                                        {
                                                            render: "Something went wrong",
                                                            icon: "❌"
                                                        }
                                                    )
                                                } else {
                                                    toast.update(loader,
                                                        {
                                                            render: "Followed user",
                                                            icon: "✔️"
                                                        }
                                                    )
                                                    getUser()
                                                }
                                            }).catch((err) => {
                                                toast.update(loader,
                                                    {
                                                        render: "Something went wrong",
                                                        icon: "❌"
                                                    }
                                                )
                                                toast.error("Something went wrong")
                                            }).finally(() => {
                                                setTimeout(() => {
                                                    toast.dismiss(loader)
                                                }, 2000)
                                            })
                                        }}>Follow</button>
                                    }
                                </>
                            }
                        </div>
                    </div>
                    {pastPolls
                        ? <Feed posts={pastPolls} />
                        : <>{pastPolls === undefined
                            ? < Spinner />
                            : <NoContent />
                        }</>
                    }
                </div>
            </PageContainer>
        )
    } else {
        return <Spinner />
    }
}
